import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import { CVService } from "../../../../../service/CVService";
import useToast from "../../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import { useQuery } from "../../../../../hooks/useQuery";
import AppFileImput from "../../../shares/AppFileImput";
import { uploadService } from "../../../../../service/UploadService";
import { enleverBaliseHtml } from "../../../../../Helpers/utilsHelper";
const INIT_FORMATION = {
  date_debut: null,
  date_fin: null,
  jour: null,
  mois: null,
  annee: null,
  jour1: null,
  mois1: null,
  annee1: null,
  domaine: null,
  theme: null,
  fid: null,
  autres: null,
  certificat: null,
};

const INIT_FORM_ERROR = {
  date_debut_error: null,
  date_fin_error: null,
  domaine_error: null,
  theme_error: null,
  fid_error: null,
  autre_error: null,
  certificat_error: null,
};
const FormationForm = ({ open, onFormClose, onFormOpen, idFormation }) => {
  const [currentFormation, setCurrentFormation] = useState(INIT_FORMATION);
  const [isSubmited, setIsSubmited] = useState(false);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const { Toast, showToast } = useToast();
  const [selectedFile, setSelectedFile] = useState(null);
  const query = useQuery();
  const id_identite = query.get("id_identite");
  const handleFormClose = () => {
    onFormClose();
    handleInitAll();
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      certificat_error: "Telechargement du fichier en cours...",
    });
    uploadService.uploadFile(file).then((res) => {
      if (!(res && res.success)) {
        showToast(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
      }
      setCurrentFormation({
        ...currentFormation,
        certificat: res && res.success ? res.data.file_name : null,
      });
      setFormErrors({
        ...formErrors,
        certificat_error:
          res && res.success ? null : enleverBaliseHtml(res.error),
      });
    });
  };

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  const handleChangeFormationData = (event) => {
    const { name, value } = event.target;
    setCurrentFormation({ ...currentFormation, [name]: value });
  };

  const handleInitAll = () => {
    setCurrentFormation(INIT_FORMATION);
    setFormErrors(INIT_FORM_ERROR);
    setIsSubmited(false);
  };

  const handleCheckError = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let dateDebutError = null;
    let dateFinError = null;

    if (!handleGetFormatedDateDebut()) {
      dateDebutError = "Date debut est requis";
    } else {
      const dateDebut = new Date(handleGetFormatedDateDebut());
      if (dateDebut >= today) {
        dateDebutError = "Date debut doit être dans le passé";
      } else if (handleGetFormatedDateFin()) {
        const dateFin = new Date(handleGetFormatedDateFin());
        if (dateDebut >= dateFin) {
          dateDebutError = "Date debut doit être antérieure à la date fin";
        }
      }
    }

    if (!handleGetFormatedDateFin()) {
      dateFinError = "Date fin est requis";
    }

    setFormErrors({
      date_debut_error: dateDebutError,
      date_fin_error: dateFinError,
      domaine_error: !currentFormation.domaine ? "Domaine est requis" : null,
      theme_error: !currentFormation.theme ? "Theme est requis" : null,
      fid_error:
        !currentFormation.fid && !currentFormation.autres
          ? "Fid ou Autre est requis"
          : null,
      autres_error:
        !currentFormation.fid && !currentFormation.autres
          ? "Fid ou Autre est requis"
          : null,
      certificat_error: null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleFetchCurrentFormation = () => {
    CVService.getFormationById(idFormation).then((res) => {
      if (res.data) {
        let curr_formation = res.data;
        curr_formation.dateDebut = `${res.data.annee}/${res.data.mois.padStart(2, "0")}/${res.data.jour.padStart(2, "0")}`;
        curr_formation.dateFin = `${res.data.annee}/${res.data.mois.padStart(2, "0")}/${res.data.jour.padStart(2, "0")}`;
        setCurrentFormation(curr_formation);
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const getInsertableFormation = () => {
    return {
      jour: currentFormation.jour,
      mois: currentFormation.mois,
      annee: currentFormation.annee,
      jour1: currentFormation.jour1,
      mois1: currentFormation.mois1,
      annee1: currentFormation.annee1,
      domaine: currentFormation.domaine,
      theme: currentFormation.theme,
      fid: currentFormation.fid || "",
      autres: currentFormation.autres || "",
      certificat: currentFormation.certificat || "",
    };
  };

  const handleInsertEducation = () => {
    const isValid = handleCheckError();
    if (isValid) {
      const formationData = getInsertableFormation();
      formationData.id_identite = id_identite;
      CVService.insertFormation(formationData).then((res) => {
        if (res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      });
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };
  const handleUpdateEducation = () => {
    const isValid = handleCheckError();
    if (isValid) {
      let formationData = getInsertableFormation();
      formationData.formation_id = idFormation;

      CVService.updateFormation(formationData).then((res) => {
        if (res.success) {
          showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
          handleFormClose();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, res.message);
        }
      });
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    if (idFormation) {
      handleUpdateEducation();
    } else {
      handleInsertEducation();
    }
  };

  const handleSetDateDebut = (value) => {
    const dateDebut = new Date(value);
    setCurrentFormation({
      ...currentFormation,
      dateDebut: value,
      jour: dateDebut.getDate(),
      mois: dateDebut.getMonth() + 1,
      annee: dateDebut.getFullYear(),
    });
  };
  const handleSetDateFin = (value) => {
    const dateFin = new Date(value);
    setCurrentFormation({
      ...currentFormation,
      dateFin: value,
      jour1: dateFin.getDate(),
      mois1: dateFin.getMonth() + 1,
      annee1: dateFin.getFullYear(),
    });
  };

  const handleGetFormatedDateDebut = () => {
    if (
      !currentFormation.annee ||
      !currentFormation.mois ||
      !currentFormation.jour
    )
      return null;
    return `${currentFormation.annee?.toString().padStart(4, "0") || ""}-${currentFormation.mois?.toString().padStart(2, "0") || ""}-${currentFormation.jour?.toString().padStart(2, "0") || ""}`;
  };

  const handleGetFormatedDateFin = () => {
    if (
      !currentFormation.annee1 ||
      !currentFormation.mois1 ||
      !currentFormation.jour1
    )
      return null;
    return `${currentFormation.annee1?.toString().padStart(4, "0") || ""}-${currentFormation.mois1?.toString().padStart(2, "0") || ""}-${currentFormation.jour1?.toString().padStart(2, "0") || ""}`;
  };

  useEffect(() => {
    if (idFormation && open) handleFetchCurrentFormation();
  }, [open, idFormation]);

  useEffect(() => {
    handleCheckError();
  }, [currentFormation]);

  return (
    <>
      <Toast />
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <Grid>
            <CardHeader title="Formation" />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Date debut *</label>
                  <TextField
                    id="date_debut"
                    name="date_debut"
                    onChange={(e) => handleSetDateDebut(e.target.value)}
                    size="small"
                    type="date"
                    placeholder="Debut debut de la formation"
                    fullWidth
                    sx={{
                      "& input": {
                        textAlign: "right",
                      },
                    }}
                    value={handleGetFormatedDateDebut()}
                    error={formErrors.date_debut_error && isSubmited}
                    helperText={isSubmited ? formErrors.date_debut_error : ""}
                    aria-describedby="nom_helper"
                  />
                  <FormHelperText id="nom_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Date fin *</label>
                  <TextField
                    id="date_fin"
                    name="date_fin"
                    onChange={(e) => handleSetDateFin(e.target.value)}
                    size="small"
                    type="date"
                    placeholder="Fin de formation"
                    fullWidth
                    sx={{
                      "& input": {
                        textAlign: "right",
                      },
                    }}
                    value={handleGetFormatedDateFin()}
                    error={formErrors.date_fin_error && isSubmited}
                    helperText={isSubmited ? formErrors.date_fin_error : ""}
                    aria-describedby="nom_helper"
                  />
                  <FormHelperText id="nom_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Domaine *</label>
                  <TextField
                    id="domaine"
                    name="domaine"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Domaine de formation"
                    fullWidth
                    value={currentFormation.domaine}
                    error={formErrors.domaine_error && isSubmited}
                    helperText={isSubmited ? formErrors.domaine_error : ""}
                    aria-describedby="domaine_helper"
                  />
                  <FormHelperText id="domaine_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Theme de formation *</label>
                  <TextField
                    id="theme"
                    name="theme"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Theme de formation"
                    fullWidth
                    value={currentFormation.theme}
                    error={formErrors.theme_error && isSubmited}
                    helperText={isSubmited ? formErrors.theme_error : ""}
                    aria-describedby="theme_helper"
                  />
                  <FormHelperText id="theme_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Fid</label>
                  <TextField
                    id="fid"
                    name="fid"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Formation FID"
                    fullWidth
                    value={currentFormation.fid}
                    error={formErrors.fid_error && isSubmited}
                    helperText={isSubmited ? formErrors.fid_error : ""}
                    aria-describedby="fid_helper"
                  />
                  <FormHelperText id="fid_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Autre</label>
                  <TextField
                    id="autres"
                    name="autres"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Autres formation"
                    fullWidth
                    value={currentFormation.autres}
                    error={formErrors.autres_error && isSubmited}
                    helperText={isSubmited ? formErrors.autres_error : ""}
                    aria-describedby="autres_helper"
                  />
                  <FormHelperText id="autres_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Certificat</label>
                  <AppFileImput
                    name="certificat"
                    placeholder={"Certificat"}
                    handleFileUpload={(evt) => {
                      handleChangeFormationData({
                        target: {
                          name: "certificat",
                          value: evt.target.files[0]?.name || "",
                        },
                      });
                      setSelectedFile(evt.target.files[0]);
                    }}
                    handleClearFile={(evt) => {
                      handleChangeFormationData({
                        target: {
                          name: "certificat",
                          value: null,
                        },
                      });
                      setSelectedFile(null);
                    }}
                    file_name={currentFormation.certificat || ""}
                    allowedFIle={".jpeg,.jpg,.png,.pdf,.docx"}
                    error={formErrors.certificat_error}
                    helperText={formErrors.certificat_error}
                  />
                  <FormHelperText id="certificat_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={handleSubmit}
              />
              <AppButton
                text={"Fermer"}
                variant={"outlined"}
                size={"medium"}
                onClick={handleFormClose}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default FormationForm;
